import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ConsultationIcon from "./consultation.png";
import WalletIcon from "./wallet.png";
import MedicineIcon from "./medicine.png";

const useStyles = makeStyles((theme) => ({
  packageDetailsContainer: {
    color: "white",
    margin: "0px",
    height: "100%",
    display: "grid",
    gridTemplateRows: "6% 11% 3% 48% auto %",
    padding: "10% 0% 0% 10%",
    [theme.breakpoints.down("sm")]: {
      padding: "20px",
    },
  },
  heading: {
    fontSize: "1.8em",
    width: "50%",
    marginLeft: "-1em",
    gridRow: "2/3",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1em",
      textAlign: "left",
      width: "60%"
    },
  },
  contentContainer: {
    marginTop: "5%",
    marginLeft: "-1.5em",
    gridRow: "4/5",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginTop: "2%",
    },
  },
  contentItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1%",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      marginBottom: "4px",
    },
  },
  icon: {
    width: "8%",
    height: "8%",
    [theme.breakpoints.down("sm")]: {
      width: "10%", // Reduce the icon size for mobile view
    },
  },
  contentText: {
    fontSize: "1.2em",
    color: "white",
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      width: "38%",
      textAlign: "left",
      fontSize: ".6em",
      // Reduce the text size for mobile view
    },
  },
  priceContainer: {
    color: "black",
    fontSize: "30px",
    marginTop: "200px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "40px",
      fontSize: "18px",
      textAlign: "left",
    },
  },
  price: {
    fontSize: "35px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px", // Reduce the price text size for mobile view
    },
  },
  durationContainer: {
    color: "#050A4E",
    fontSize: "12px",
    marginTop: "10px",
    borderStyle: "dotted",
    borderRadius: 10,
    width: "fit-content",
    textAlign: "center",
    padding: "2px 10px",
    [theme.breakpoints.down("sm")]: {
        fontSize: "10px",
    },
  },
}));

const PackageDetailsComponent = (props) => {
  const classes = useStyles();
  const contents = [
    {
      icon: ConsultationIcon,
      text: props.package.content[0],
    },
    {
      icon: WalletIcon,
      text: props.package.content[1],
    },
    {
      icon: MedicineIcon,
      text: props.package.content[2],
    },
  ];
  const price = props.package.price;
  const strikePrice = props.package.strikePrice;
  const members = props.package.members;
  const duration = props.package.duration;

  return (
    <div className={classes.packageDetailsContainer}>
      <div className={classes.heading} style={{}}>
        <b>Exclusive benefits for Aditya Birla Housing Finance Customers:</b>
      </div>
      <div className={classes.contentContainer}>
        {contents.map((data) => (
          <div key={data.text} className={classes.contentItem}>
            <img className={classes.icon} src={data.icon} alt="Icon" />
            <div className={classes.contentText}>
              <div dangerouslySetInnerHTML={{ __html: data.text }} />
            </div>
          </div>
        ))}
      </div>
     
     <div style={{gridRow: "6"}}>
      <div className={classes.priceContainer}>
          ₹ {strikePrice && <del> {strikePrice}/-</del>} <br />
          <b className={classes.price}> ₹ {price} /-</b>
        </div>
        <div className={classes.durationContainer}>
          {duration} | {members} Members
        </div>
      </div>
    </div>
  );
};

export default PackageDetailsComponent;
